// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"9d234b5b","421":"9d234b5b","818":"77e24a2e","883":"9d234b5b","889":"9d234b5b"}[chunkId] + ".chunk.css";
};